var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Detail",staticStyle:{"bottom":"0"}},[_c('vueTemplate',{ref:"vueTemplate",attrs:{"viewType":"seas","sysBoxValue":_vm.sysBoxValue,"cusBoxValue":_vm.cusBoxValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }